export const plans = [
  {
    title: "Hot Discount Days",
    desc: "Each Friday we deliver highest discounts",
    author: "Min Jae",
    date: "30 min ago",
    location: "Seoul, Korea",
    img: "/img/friday.jpg",
  },
  {
    title: "Coming Soon",
    desc: "Be ready for fresh Arrivals from Monday!",
    author: "John Doe",
    date: "2 days ago",
    location: "Seoul, Korea",
    img: "/img/coming.png",
  },
  {
    title: "New Project Lunch",
    desc: "New Store is opening in Florida",
    author: "Morgan News",
    date: "5 days ago",
    location: "USA, Florida",
    img: "/img/ibeauty.jpg",
  },
  {
    title: "Join us on sns",
    desc: "🥬 We are offering healthy products info on sns",
    author: "Duran Agent",
    date: "A week ago",
    location: "Europe, France",
    img: "/img/healthy-beauty.jpg",
  },
];
